import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Table } from 'shared/mui/Table';
import { BooleanInput } from 'shared/react-admin/Inputs';

export const StyledTable = styled(Table)(({ theme }) => ({
  marginBottom: '24px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
  '& .MuiTableCell-head': {
    verticalAlign: 'top',
    height: 64,
    padding: '16px',
  },
  '& .MuiTableCell-head span': {
    lineHeight: 1,
  },
  '& .MuiTableRow-root': {
    height: 56,
  },
  '& tr:has(.Mui-checked)': {
    background: 'transparent',
  },
  '& .MuiFormHelperText-root': {
    display: 'none',
  },
}));

export const StyledBooleanInput = styled(BooleanInput)({
  alignItems: 'center',
  '& .MuiFormControlLabel-root': {
    marginRight: 0,
  },
});

export const StyledBox = styled(Box)({
  display: 'flex',
  width: '100%',
  padding: '15px 16px',
  marginBottom: '24px',
  background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #0288D1',
  borderRadius: '4px',
});
